module.exports = __webpack_public_path__ + "static/media/NSD_1.553a640c.jpg";